import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import BottomSheet from "@/components/BottomSheet";
import { formatNominalInput, parseNominal } from "@/lib/format";

const BANK_OPTIONS = [
  "BCA",
  "Mandiri",
  "BRI",
  "BNI",
  "CIMB",
  "GoPay",
  "OVO",
  "Dana",
  "Lainnya",
];

export default function RekeningForm({ open, onClose, onSaved, existing = null }) {
  const [nama, setNama] = useState(existing?.nama || "");
  const [bank, setBank] = useState(existing?.bank || "BCA");
  const [saldoAwal, setSaldoAwal] = useState(
    existing?.saldo_awal ? formatNominalInput(existing.saldo_awal) : ""
  );
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setNama(existing?.nama || "");
      setBank(existing?.bank || "BCA");
      setSaldoAwal(
        existing?.saldo_awal ? formatNominalInput(existing.saldo_awal) : ""
      );
    }
  }, [open, existing]);

  const submit = async (e) => {
    e.preventDefault();
    if (!nama.trim()) return toast.error("Nama rekening wajib diisi");
    const s = parseNominal(saldoAwal);
    setBusy(true);
    try {
      const payload = { nama: nama.trim(), bank, saldo_awal: s };
      if (existing) {
        await api.put(`/rekening/${existing.id}`, payload);
        toast.success("Rekening diperbarui");
      } else {
        await api.post("/rekening", payload);
        toast.success("Rekening ditambahkan");
      }
      onClose();
      onSaved && onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title={existing ? "Edit Rekening" : "Tambah Rekening"}
      testId="rekening-form-sheet"
    >
      <form onSubmit={submit} className="space-y-4" data-testid="rekening-form">
        <Field label="Nama rekening">
          <input
            type="text"
            value={nama}
            onChange={(e) => setNama(e.target.value)}
            data-testid="rekening-input-nama"
            className={inputCls}
            placeholder="mis. BCA Utama"
            required
          />
        </Field>
        <Field label="Bank / dompet">
          <select
            value={bank}
            onChange={(e) => setBank(e.target.value)}
            data-testid="rekening-input-bank"
            className={inputCls}
          >
            {BANK_OPTIONS.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
          </select>
        </Field>
        <Field label="Saldo awal (Rp)">
          <input
            type="text"
            inputMode="numeric"
            value={saldoAwal}
            onChange={(e) => setSaldoAwal(formatNominalInput(e.target.value))}
            data-testid="rekening-input-saldo"
            className={inputCls}
            placeholder="0"
          />
        </Field>
        <button
          type="submit"
          disabled={busy}
          data-testid="rekening-submit"
          className="w-full h-11 rounded-xl font-semibold text-sm text-white tap disabled:opacity-60"
          style={{ backgroundColor: "#1F4E5F" }}
        >
          {busy ? "Menyimpan..." : "Simpan"}
        </button>
      </form>
    </BottomSheet>
  );
}

const inputCls =
  "mt-1 w-full h-11 px-3 rounded-xl border border-slate-200 focus:border-[#1F4E5F] focus:outline-none text-sm bg-white";

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold text-slate-600">{label}</span>
      {children}
    </label>
  );
}
